import * as types from './mutations-types';
import { isEmpty } from 'lodash-es';
import { clientApi } from '@phoenix/clientApi';

const initialState = {
  storePageId: null,
  query: null,
  stores: [],
  isLoading: false,
};

const actions = {
  async searchStore({ commit }, { query, boutiqueOnly }) {
    if (isEmpty(query)) {
      return;
    }

    commit(types.STORE_SELECTOR_SET_QUERY, query);
    commit(types.STORE_SELECTOR_SET_LOADING, true);

    try {
      const { data } = await clientApi.get(window.route('api.search.stores'), {
        params: { keyword: query, boutiqueOnly },
      });

      window.dataLayer.push({
        event: 'searchBoutique',
        term: query,
        nbResultsboutique: data.data.length,
      });

      commit(types.STORE_SELECTOR_SET_STORES, data.data);
      commit(types.STORE_SELECTOR_SET_LOADING, false);
    } catch (error) {
      window.Phoenix.sentry.captureException(error);
    }
  },

  setStorePageId({ commit }, storePageId) {
    commit(types.STORE_SELECTOR_SET_STORE_PAGE_ID, storePageId);
  },

  reset({ commit }) {
    commit(types.STORE_SELECTOR_RESET);
  },

  empty({ commit }) {
    commit(types.STORE_SELECTOR_EMPTY);
  },
};

const mutations = {
  [types.STORE_SELECTOR_SET_STORE_PAGE_ID](state, storePageId) {
    state.storePageId = storePageId;
  },

  [types.STORE_SELECTOR_SET_QUERY](state, query) {
    state.query = query;
  },

  [types.STORE_SELECTOR_SET_STORES](state, stores) {
    state.stores = stores;
  },

  [types.STORE_SELECTOR_SET_LOADING](state, isLoading) {
    state.isLoading = isLoading;
  },

  [types.STORE_SELECTOR_RESET](state) {
    state.storePageId = null;
    state.query = null;
    state.stores = null;
  },

  [types.STORE_SELECTOR_EMPTY](state) {
    state.query = null;
    state.stores = null;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
